/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterCategory_filters = ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
        readonly count: number | null;
        readonly displayName: string | null;
        readonly linkReference: string | null;
        readonly linkable: boolean | null;
    } | null> | null;
    readonly " $refType": "SbRespRefineMenuFilterCategory_filters";
}>;
export type SbRespRefineMenuFilterCategory_filters$data = SbRespRefineMenuFilterCategory_filters;
export type SbRespRefineMenuFilterCategory_filters$key = ReadonlyArray<{
    readonly " $data"?: SbRespRefineMenuFilterCategory_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterCategory_filters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterCategory_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "values",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseFilterValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "linkReference",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "linkable",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'e9becde0671167fac5f743f86fecec85';
export default node;
